const returnUrlKey = "returnUrl";

const setReturnUrl = (url: string) => {
  localStorage.setItem(returnUrlKey, url);
};
const getReturnUrl = () => {
  return localStorage.getItem(returnUrlKey) || "";
};
const clearReturnUrl = () => {
  localStorage.removeItem(returnUrlKey);
};

export { setReturnUrl, getReturnUrl, clearReturnUrl };